var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFind({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 11.5C1.25 17.15 5.85 21.75 11.5 21.75C17.15 21.75 21.75 17.15 21.75 11.5C21.75 5.85 17.15 1.25 11.5 1.25C5.85 1.25 1.25 5.85 1.25 11.5ZM2.75 11.5C2.75 6.68 6.67 2.75 11.5 2.75C16.33 2.75 20.25 6.68 20.25 11.5C20.25 16.32 16.33 20.25 11.5 20.25C6.67 20.25 2.75 16.32 2.75 11.5Z",
    fill: "#1B75BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4699 22.5299C21.6199 22.6799 21.8099 22.7499 21.9999 22.7499C22.1899 22.7499 22.3799 22.6799 22.5299 22.5299C22.8199 22.2399 22.8199 21.7599 22.5299 21.4699L20.5299 19.4699C20.2399 19.1799 19.7599 19.1799 19.4699 19.4699C19.1799 19.7599 19.1799 20.2399 19.4699 20.5299L21.4699 22.5299Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/Find.efe85019d0c80b7fd7411c041f7d66be.svg";
export { ForwardRef as ReactComponent };